<template>
    <v-card class="pa-6">
        <v-row>
            <v-col cols="12" md="6" lg="6">
                <v-radio-group
                v-model="type"
                row
                >
                <v-radio
                    class="mr-12"
                    label="Grupo"
                    value="group"
                ></v-radio>
                <v-radio
                    label="Usuário"
                    value="user"
                ></v-radio>
                </v-radio-group>
                <v-autocomplete
                    v-model="selectedChannel"
                    :items="channelsSearch"
                    :loading="loading"
                    item-text="name"
                    item-value="id_channel"
                    label="Selecione o Canal"
                    placeholder="Digite para buscar..."
                    clearable
                    multiple
                ></v-autocomplete>
                <v-textarea
                    v-model="textMessage"
                    label="Mensagem"
                    placeholder="Digite a mensagem"
                    outlined
                ></v-textarea>
                <v-file-input
                    v-model="file"
                    label="Arquivo"
                    placeholder="Selecione um arquivo"
                    clearable
                    outlined
                ></v-file-input>
                
                <v-btn v-if="file" color="primary" @click="sendMessageFile" :disabled="!selectedChannel || !textMessage || !file" >Enviar Arquivo</v-btn>
                <v-btn v-else color="primary" @click="sendMessage" :disabled="!selectedChannel || !textMessage" >Enviar</v-btn>
            </v-col>

            <v-col cols="12" md="6" lg="6">
                <TableChannels
                    :channels="channels"
                    :loading="loading"
                    @refresh="fetchChannels"
                />
            </v-col>

        </v-row>

    </v-card>
</template>

<script>
import toast from "@/commom/toast";
import ChannelsSlack from "@/services/http/rpa/ChannelsSlack";
import TableChannels from "./TableChannels.vue";
export default {
    name: "Mensagem",
    components: {
        TableChannels,
    },
    data: () => ({
        selectedChannel: null,
        textMessage: null,
        loading: false,
        channels: [],
        channelsSearch: [],
        file: null,
        type: "group",
    }),
    watch: {
        type: {
            handler(newValue) { 
                this.selectedChannel = null;
                this.searchChannels(newValue);
            },
        },
    },
    methods: {
        async searchChannels(type) {
            this.channelsSearch = this.channels.filter(channel => channel.type === type);
        },

        async fetchChannels() {
            try {
                this.loading = true;
                const { data } = await ChannelsSlack().show({ per_page: -1 });
                this.channels = data.data;
                this.channelsSearch = data.data.filter(channel => channel.type === this.type);
                this.loading = false;
            } catch (error) {
                toast("error", "Erro ao carregar canais");
            }
        },

        async sendMessage() {
            try {
                const response = this.selectedChannel.map(async (channel) => {
                    await ChannelsSlack().sendMessageStore({
                        channel,
                        text: this.textMessage,
                    });
                });
                
                await Promise.all(response);
                toast("success", "Mensagem enviada com sucesso");
                
                
            } catch (error) {
                toast("error", "Erro ao enviar mensagem");
            }finally {
                this.clearForm();
            }
        },

        async sendMessageFile() {
            try {
                const response = this.selectedChannel.map(async (channel) => {
                    const formData = new FormData();
                    formData.append("channel", channel);
                    formData.append("text", this.textMessage);
                    formData.append("file", this.file);

                    await ChannelsSlack().sendMessageFileStore(formData);
                });
                
                await Promise.all(response);
                toast("success", "Mensagem enviada com sucesso");
            } catch (error) {
                toast("error", "Erro ao enviar mensagem");
            }finally {
                this.clearForm();
            }
        },

        clearForm() {
            this.selectedChannel = null;
            this.textMessage = null;
            this.file = null;
        },

    },
    mounted() {
        this.fetchChannels();
    },
}
</script>